<script lang="ts">
  import { Banners, BannersDTO } from "@frontend/walletapi";
  import { service } from "../services";
  import { GetCachedToken, me } from "../user";
  import { onMount } from "svelte";
  import Modal from "@frontend/Components/Modal.svelte";
  import { push } from "svelte-spa-router";
  import AddBanner from "@frontend/Components/AddBanner.svelte";
  import EditBanner from "@frontend/Components/EditBanner.svelte";
  import { banners } from "@frontend/Bannerlist";
  import Pagination from "@frontend/Components/Pagination.svelte";
  import { translate, currentLanguage } from "../Translator";
  export let params: RouteParams = undefined;
 
  let bannerlist: BannersDTO[] = [];
  let currentPage = 1;
  const pageSize = 20;
  $: visibleBanners = bannerlist.slice((currentPage - 1) * pageSize, currentPage * pageSize);

   type RouteParams = EditAction | AddAction | undefined;

   type EditAction = {
        action: "edit",
        bannerid: number;
    };

      type AddAction = {
        action: "add"
    };

     function dismiss() {
        push("/BannersList");
    }

     let selectedBanner: BannersDTO | undefined = undefined;
    $: if (params) {
        if (params.action == "edit") {
            let selectedBannerId = params.bannerid;
            selectedBanner = $banners.find(s => s.Id == selectedBannerId);
        }
    }
    
  onMount(async () => {
    // Verificar autenticación primero
    if (!$me) {
      push("/user/Login");
      return;
    }

    const req = { Token: GetCachedToken() };
    const result = await service.walletapi.bannersList(req);
    if (result.Success && result.Data) {
      bannerlist = result.Data;
      banners.set(result.Data);
    } else {
      bannerlist = [];
      // Opcional: puedes mostrar un mensaje de error aquí
    }
  });

  let message: { text: string; type: string } = { text: '', type: '' };

  async function DisableBanner(banner: BannersDTO) {
    try {
      const result = await service.walletapi.disableBanner({
        Token: GetCachedToken(),
        Data: {
          Id: banner.Id,
          Enabled: banner.Enabled
        }
      });

      if (result.Success) {
        // Actualizar el estado local del banner
        banner.Enabled = !banner.Enabled;
        
        // Actualizar la lista de banners
        bannerlist = bannerlist.map(b => {
          if (b.Id === banner.Id) {
            return { ...b, Enabled: banner.Enabled };
          }
          return b;
        });

        // Actualizar el store de banners
        banners.update(currentBanners => 
          currentBanners.map(b => {
            if (b.Id === banner.Id) {
              return { ...b, Enabled: banner.Enabled };
            }
            return b;
          })
        );

        message = {
          text: `Banner has been ${banner.Enabled ? 'enabled' : 'disabled'} successfully`,
          type: 'success'
        };
      } else {
        message = {
          text: result.ErrorMessage || 'Error updating banner status',
          type: 'error'
        };
      }
    } catch (err) {
      message = {
        text: err instanceof Error ? err.message : 'An unexpected error occurred',
        type: 'error'
      };
    }

    // Auto-hide message after 3 seconds
    setTimeout(() => {
      message = { text: '', type: '' };
    }, 3000);
  }

</script>
{#if params?.action == "add"}
    <Modal dismiss={dismiss}>
        <AddBanner dismiss={dismiss} />
    </Modal>
{/if}

{#if params?.action == "edit"}
    <Modal dismiss={dismiss}>
        {#if !selectedBanner}
            <div class="ui negative message">
                <div class="header">No such server</div>
            </div>
        {:else}
            <EditBanner banner={selectedBanner} dismiss={dismiss} />
        {/if}
    </Modal>
{/if}

<h1 class="ui centered dividing header">{$translate('list of banners')}</h1>

<a href="#/BannersList/add" class="ui green button">
    <i class="plus icon"></i>
    {$translate('Add Banner')}
</a>
<table class="ui celled table">
    <thead>
        <tr>
            <th class="center aligned">{$translate('Id')}</th>
            <th class="center aligned">{$translate('Banner')}</th>
            <th class="center aligned">{$translate('Link')}</th>
            <th class="center aligned">{$translate('Enabled')}</th>
            <th class="center aligned">{$translate('BigSelect')}</th>
            <th class="center aligned">{$translate('SmallSelect')}</th>
            <th class="center aligned">{$translate('Options')}</th>
        </tr>
    </thead>
    <tbody>
        {#each visibleBanners ?? [] as banner}
            <tr>
                <td class="center aligned">{banner.Id}</td>
                <td class="center aligned">{banner.BannerName ?? ""}</td>
                <td class="center aligned">{banner.Link ?? ""}</td>
                <td class="center aligned">
                 <button class={`ui icon small button ${banner.Enabled ? 'positive' : 'negative'}`} on:click={() => DisableBanner(banner)}>
                    {#if banner.Enabled}
                      <i class="check icon"></i>
                    {:else}
                      <i class="close icon"></i>
                    {/if}
                </button>
                </td>
                <td class="center aligned"> {#if banner.BigSelect}
                    <img src={banner.BigSelect} alt="Big Banner" style="max-width: 100px; max-height: 60px;" />
                  {:else}
                    <span>No image</span>
                  {/if}</td>
                <td class="center aligned">{#if banner.SmallSelect}
                    <img src={banner.SmallSelect} alt="Big Banner" style="max-width: 100px; max-height: 60px;" />
                  {:else}
                    <span>No image</span>
                  {/if}</td>
                 <td class="center aligned">
                    <a href="#/BannersList/edit/{banner.Id}" class="ui icon primary button">
                        <i class="edit icon"></i>
                    </a>
                </td>
            </tr>
        {/each}
    </tbody>
</table>
<Pagination page={currentPage} totalItems={bannerlist.length} {pageSize} on:change={(event) => currentPage = event.detail} />

<style>
    /* Estilos para centrar todo el contenido de la tabla */
    .ui.celled.table th,
    .ui.celled.table td {
        text-align: center !important;
        vertical-align: middle !important;
    }

    /* Asegurar que las imágenes estén centradas */
    .ui.celled.table img {
        display: block;
        margin: 0 auto;
    }

    /* Asegurar que el texto esté centrado */
    .ui.celled.table td span {
        display: block;
        text-align: center;
    }
</style>
